import React from 'react';
import { times } from 'lodash';
import { MutationUpdaterFn } from 'react-apollo';
import RQLFeedItem from './rql_feed_item';
import { MixedFeedRow, RemoveFeedEntry } from '../schemas/rql';

import OverflowingRow from '@reverbdotcom/commons/src/components/overflowing_row';
import Tiles from '@reverbdotcom/commons/src/components/tiles';
import { RCListingGrid } from '@reverbdotcom/cadence/components';
import { useTheme } from '@reverbdotcom/commons/src/components/theme_context_provider';
import { ThemeType } from '@reverbdotcom/cadence/components/types';

interface IProps {
  expectedCount: number;
  entries: MixedFeedRow.Fragment[];
  loading: boolean;
  cta?: JSX.Element;
  title?: string;
  singleRow?: boolean;
  removeFeedItemFromCache?: (entryId: number) => MutationUpdaterFn<RemoveFeedEntry.Mutation>;
}

export default function FeedRow(props: IProps) {
  const themeContext = useTheme();
  const useRCListingGrid = themeContext?.theme === ThemeType.web2;

  return (
    <OverflowingRow
      collectionCount={props.entries.length}
      action={props.cta}
      title={props.title}
    >
      {useRCListingGrid ? (
        <RCListingGrid
          singleRow={props.singleRow}
          loading={props.loading}
        >
          {props.loading && props.entries.length === 0 ? (
            renderGridPlaceholders(props.expectedCount)
          ) : (
            props.entries.map((entry, idx) => (
              <RCListingGrid.Item
                key={entry.id}
              >
                <RQLFeedItem
                  key={`${entry.__typename}-${entry.id}-${idx}`}
                  entry={entry}
                  position={idx}
                  removeFeedItemUpdateCallback={props.removeFeedItemFromCache(entry.id)}
                />
              </RCListingGrid.Item>
            ))
          )}
        </RCListingGrid>
      ) : (
        <Tiles
          placeholder={<RQLFeedItem />}
          loading={props.loading}
          expectedCount={props.expectedCount}
          largeTiles
          singleRow={props.singleRow}
        >
          {props.entries.map((entry, idx) => (
            <RQLFeedItem
              key={`${entry.__typename}-${entry.id}-${idx}`}
              entry={entry}
              position={idx}
              removeFeedItemUpdateCallback={props.removeFeedItemFromCache(entry.id)}
            />
          ))}
        </Tiles>
      )}
    </OverflowingRow>
  );
}

function renderGridPlaceholders(count) {
  return times(count, index => (
    <RCListingGrid.Item
      key={index}
    >
      <RQLFeedItem />
    </RCListingGrid.Item>
  ));
}
